<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefList"
          :export-file-name="priceUtil.getFileName(fileName)"
          :row-data="rowData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'

export default {
  name: 'FclExtraDataGrid',
  components: {},
  props: {
    configModule: { type: String, default: '220600' },
    showBranch: { type: Boolean, default: true },
    showCreate: { type: Boolean, default: true },
    showModify: { type: Boolean, default: true },
    showApprove: { type: Boolean, default: false },
    showCheckBox: { type: Boolean, default: true },
    filter: { type: Object, default: () => {} },
    fileName: { type: String, default: 'PriceFCLExtra' },
    source: { type: String, default: '' },
    gridOptions: { type: Object, default: () => {} },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      URL,
      priceTypes: PriceConstant.PRICE_ALL_TYPES,
      freeTimeType: PriceConstant.FREE_TIME_TYPE,
      showLevel: false, // 是否显示运价等级
      txtRemarks: '',
      priceUtil: PriceUtils,
      remarkChange: false,
      authedLevel: 99,
      proxy: {},
      filterJson: {},
      showDetail: false,
      fullscreenLoading: false,
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', checkboxSelection: true,
          hide: !this.showCheckBox, suppressColumnsToolPanel: !this.showCheckBox,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          } },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Pricing.Lane'), field: 'lane', colId: 'lane', width: 200 },
        { headerName: this.$t('Pricing.Dockland'), field: 'dockland', colId: 'dockland', width: 200 },
        {
          headerName: this.$t('Pricing.ShareCarriers'), field: 'shareCarrier', colId: 'shareCarrier', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.moreCompanyLabelFun(params.value, 'shortName', 'cmpIdx')
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.shareCarrierTipFunc(params.data)
          }
        },
        { headerName: this.$t('Pricing.BillType'), field: 'billType', colId: 'billType', width: 200 },
        { headerName: this.$t('Pricing.ShippingClause'), field: 'shippingTerm', colId: 'shippingTerm', width: 200 },
        { headerName: 'SEAWAY BILL', field: 'seawayBill', colId: 'seawayBill', width: 200 },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.CreatedBy'), field: 'createdBy', colId: 'createdBy', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.CreatedDate'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedDate'), field: 'dateModified', colId: 'dateModified', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedBy'), field: 'approvedBy', colId: 'approvedBy', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedDate'), field: 'dateApproved', colId: 'dateApproved', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.PriceType'), field: 'freightType', colId: 'freightType', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return CommonState.getNameByCode(this.priceTypes, params.value)
          }
        },
        { headerName: this.$t('Pricing.FreeTimeType'), field: 'freeContainerPeriodType', colId: 'freeContainerPeriodType', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return CommonState.getNameByCode(this.freeTimeType, params.value)
          }
        },
        { headerName: 'DEM+DET', field: 'freeContainerPeriod', colId: 'freeContainerPeriod', width: 200,
          hide: true,
          cellRenderer: (params) => {
            return params.value
          }
        },
        { headerName: 'Demurrage', field: 'dem', colId: 'dem', width: 200,
          hide: true,
          cellRenderer: (params) => {
            return params.value
          }
        },
        { headerName: 'Detention', field: 'det', colId: 'det', width: 200,
          hide: true,
          cellRenderer: (params) => {
            return params.value
          }
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    columnDefList() {
      let list = this.columnDefs
      if (this.showBranch) {
        list = [
          ...this.columnDefs,
          { headerName: this.$t('Pricing.Branch'), field: 'branchId', colId: 'branchId', width: 200,
            hide: !this.showCreate && this.showBranch, suppressColumnsToolPanel: !this.showCreate && this.showBranch,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
            }
          }
        ]
      }
      if (this.source === 'priceFCLExtra') {
        list = [
          ...list,
          {
            headerName: this.$t('Pricing.DepartureDay'), field: 'frequency', colId: 'frequency', width: 200
          }
        ]
      } else {
        list = [
          ...list,
          {
            headerName: this.$t('Pricing.DepartureDay'), field: 'frequency', colId: 'frequency', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.frequencyLabelFunc(params.data, 'frequency')
            }
          }
        ]
      }
      return list
    }
  },
  watch: {
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.gridOptions.onRowClicked = this.onRowClickedEvent
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.$emit('selectRowChange', data) // 行选中回调
    }
  }
}
</script>
<style lang="scss">
</style>

